/**
 * 将所有的cac整改配置收拢到该文件，将代码里的写死域名之类的也收拢到该文件，在此集中disable相关eslint
 */
import DocsConfig from '@tencent/docs-config';
export var appConfigInstance = DocsConfig.getInstance();
